import React from "react";
import { Vehicles } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <Vehicles />
      </>
    </div>
  );
}
